import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgbModal, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { IRootState } from '../app.config';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { bootstrapDoorOpen, bootstrapGear, bootstrapList, bootstrapMenuButtonWide, bootstrapX } from '@ng-icons/bootstrap-icons';
import { AsyncPipe, CommonModule, NgClass } from '@angular/common';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { NavigationItem, selectNavigationItems } from '../../shared/navigation/navigation.reducer';
import { NavigationComponent } from './navigation/navigation.component';
import { BrandingLogoDisplayComponent } from '../../shared/branding/branding-logo-display/branding-logo-display.component';
import { logout } from '../../shared/auth/authentication.actions';
import { loadAppConfiguration, loadBrandingConfiguration } from '../../shared/app-configuration/app-configuration.actions';
import { UserConfigurationModalComponent } from '../../shared/modals/user-configuration-modal/user-configuration-modal.component';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { IUserConfiguration, selectFreightTypesEnabled, selectIsUserConfigurationLoaded, selectUserState } from '../../shared/user/user.reducer';
import { loadUserConfiguration } from '../../shared/user/user.actions';

@Component({
  selector: 'app-base-template',
  standalone: true,
  imports: [NavigationComponent, AsyncPipe, RouterOutlet, NgIcon, BrandingLogoDisplayComponent, CommonModule, NgClass],
  templateUrl: './base-template.component.html',
  styleUrl: './base-template.component.scss',
  viewProviders: [provideIcons({
    bootstrapMenuButtonWide, bootstrapDoorOpen,
    bootstrapGear,
    bootstrapList,
    bootstrapX
  })],
  animations: [
    trigger('iconRotate', [
      state('open', style({ transform: 'rotate(90deg)' })),
      state('closed', style({ transform: 'rotate(0deg)' })),
      transition('open <=> closed', [
        animate('0.35s ease-in-out')
      ]),
    ]),
    trigger('drawerSlide', [
      state('open', style({ width: 200 })),
      state('closed', style({
        width: 0,
        display: 'none'
      })),
      transition('open <=> closed', [
        animate('0.35s ease-in-out')
      ]),
    ]),
  ]
})
export class BaseTemplateComponent implements OnInit {
  navigationItems$: Observable<NavigationItem[]> | undefined = undefined;
  isNavigationOpen: boolean = false;
  userConfig$: Observable<IUserConfiguration> | undefined = undefined;
  freightTypesEnabled$: Observable<{
    generalFreightEnabled: boolean | undefined;
    specialisedFreightEnabled: boolean | undefined;
    containersEnabled: boolean | undefined;
  }> | undefined = undefined;

  constructor(private offCanvasService: NgbOffcanvas, private store$: Store<IRootState>, private modalService: NgbModal) { }

  ngOnInit() {
    this.store$.dispatch(loadAppConfiguration());
    this.store$.dispatch(loadBrandingConfiguration());
    this.store$.select(selectIsUserConfigurationLoaded).subscribe((isLoaded) => {
      if (!isLoaded) {
        this.store$.dispatch(loadUserConfiguration());
      }
    });

    localStorage.getItem('navigationOpen') === 'true' ? this.isNavigationOpen = true : this.isNavigationOpen = false;

    this.navigationItems$ = this.store$.select(selectNavigationItems);
    this.freightTypesEnabled$ = this.store$.select(selectFreightTypesEnabled);
    this.userConfig$ = this.store$.select(selectUserState);
  }

  logout() {
    this.store$.dispatch(logout())
  }

  openConfiguration() {

    this.store$.select(selectUserState).pipe(take(1)).subscribe((user) => {
      const modalRef = this.modalService.open(UserConfigurationModalComponent, { size: 'lg' });
      modalRef.componentInstance!.userData = { name: user.name };
    });
  }

  toggleNavigation() {
    this.isNavigationOpen = !this.isNavigationOpen

    localStorage.setItem('navigationOpen', this.isNavigationOpen.toString());
  }
}
